import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Typography, Button, Box } from "@mui/material";
import axios from "axios";
import { useEffect } from "react";


function ResultPage({topic,difficulty, }) {
  const location = useLocation();
  const navigate = useNavigate();
  useEffect(() => {
    const saveResult = async () => {
      try {
        await axios.post("https://YOUR_XANO_API/submit-result", {
          topic,
          difficulty,
          score,
          total,
        //   percent
        });
      } catch (err) {
        console.error("שגיאה בשליחת תוצאה", err);
      }
    };
    saveResult();
  }, []);

  const { score, total } = location.state || { score: 0, total: 0 };
  const percentage = Math.round((score / total) * 100);

  return (
    <Container dir="rtl" sx={{ mt: 5, textAlign: "center" }}>
      <Typography variant="h4" gutterBottom>
        סיום מבחן
      </Typography>
      <Typography variant="h6">
        ענית נכון על {score} מתוך {total} שאלות
      </Typography>
      <Typography variant="h5" color="primary" sx={{ mt: 2 }}>
        ציון: {percentage}%
      </Typography>

      <Box mt={4}>
        <Button
          variant="contained"
          onClick={() => navigate("/")}
          fullWidth
        >
          חזור לעמוד הראשי
        </Button>
      </Box>
    </Container>
  );
}

export default ResultPage;
